import { Controller } from "@hotwired/stimulus"
import { newNameIn, restoreNewName } from "../helpers/combobox_new_name.js"

// An assignee picker that accepts a name the Farm doesn't have (ADR 0090). A new name must be answered as a
// contractor or a contractor group before the form saves; the form hears new-assignee:change with that kind (null
// for an existing assignee), and connecting: true for the report made as the picker connects, which is no new pick.
export default class extends Controller {
  static targets = ["panel", "name", "kind", "groupHint"]
  static values = { pending: Boolean }

  connect() {
    if (this.pendingValue) restoreNewName(this.element)
    this.#report(true)
  }

  update() {
    this.#report(false)
  }

  #report(connecting) {
    const name = newNameIn(this.element)
    this.panelTarget.classList.toggle("hidden", !name)
    this.nameTarget.textContent = name ? `«${name}»` : ""
    this.kindTargets.forEach((input) => {
      input.disabled = !name
      if (!name) input.checked = false
    })

    const kind = this.kindTargets.find((input) => input.checked)?.value || ""
    this.groupHintTarget.classList.toggle("hidden", kind !== "contractor_group")
    this.dispatch("change", { detail: { assignee: name ? { name, kind } : null, connecting } })
  }
}
